<template>
  <div>
    <div id="helpInfo" class="helpinfo">
      <div class="wrap-lg">
        <div class="clearfix">
          <div class="f_link">
            <div class="helpinfo-item">
              <div class="helpinfo-title">帮助中心</div>
              <ul>
                <li><a :href=" host.sgsonlineUrl + '/overview/process'" target="_blank">新手指南</a></li>
                <li><a :href=" host.sgsonlineUrl + '/overview/terms-and-conditions'" target="_blank" rel="nofollow">服务条款</a>
                </li>
                <li><a :href=" host.sgsonlineUrl + '/DocCheck'" target="_blank">报告验证</a></li>
                <li><a :href=" host.sgsonlineUrl + '/overview/process'" target="_blank" rel="nofollow">订购流程</a></li>
                <li><a :href=" host.sgsonlineUrl + '/sitemap'" target="_blank" rel="nofollow">网站地图</a></li>
              </ul>
            </div>
          </div>
          <div class="f_link">
            <div class="helpinfo-item">
              <div class="helpinfo-title">我们的服务</div>
              <ul>
                <li><a :href="host.sgsonlineUrl + '/service/testing/'" target="_blank">测试</a></li>
                <li><a :href="host.sgsonlineUrl + '/service/inspection/'" target="_blank">检验</a></li>
                <li><a :href="host.sgsonlineUrl + '/service/auditing/'" target="_blank">审核</a></li>
                <li><a :href="host.sgsonlineUrl + '/service/certification/'" target="_blank">认证</a></li>
                <li><a :href="host.sgsonlineUrl + '/service/training/'" target="_blank">培训</a></li>
              </ul>
            </div>
          </div>
          <div class="f_link">
            <div class="helpinfo-item">
              <div class="helpinfo-title">关于我们</div>
              <ul>
                <li><a :href="host.sgsonlineUrl + '/overview/aboutSGS'" target="_blank">关于SGS</a></li>
                <li><a
                    href="https://www.sgsgroup.com.cn/zh-cn/our-company/about-sgs/sgs-in-brief/sgs-in-china/qualifications"
                    target="_blank">认可资质</a></li>
                <li><a href="https://www.sgsgroup.com.cn/" target="_blank">SGS官网</a></li>
                <li><a :href="host.sgsonlineUrl + '/news'" target="_blank">新闻中心</a></li>
                <li><a :href="host.sgsonlineUrl + '/seoList'" target="_blank">服务推广</a></li>
                <li><a :href="host.sgsonlineUrl + '/overview/notice'" target="_blank">版权声明</a></li>
              </ul>
            </div>
          </div>
          <div class="f_link">
            <div class="helpinfo-item">
              <div class="helpinfo-title">应用网站</div>
              <ul>
                <li><a href="https://inspection-olb.sgs.com" target="_blank">CRS IS</a></li>
                <li><a href="https://rsts.cn.sgs.com/" target="_blank">RSTS 报告核查</a></li>
              </ul>
            </div>
          </div>
          <div class="f_link">
            <div class="helpinfo-item helpinfo-email">
              <div class="helpinfo-title">联系客服</div>
              <ul>
                <li>
                  <a @click="handleHotline">咨询热线：<span class="hotlineText">4008-855-558</span></a>
                </li>
                <li>
                  <span>周一~周六9：00至17：00（节假日除外）如遇忙线，请给我们<a :href="host.sgsonlineUrl + '/baojia'" class="highlight"
                      target="_blank">留言</a>，工作日最快2小时回复</span>
                </li>
                <li>
                  <span>邮箱：online@sgs.com</span>
                </li>
                <li>
                  <label>
                    地址：
                  </label>
                  <em>
                    北京市海淀区阜成路73号世纪裕惠大厦16层
                  </em>
                </li>
                <li>
                  <a @click="handleHotlineOther">非业务咨询专线</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="f_link">
            <div class="QRcode">
              <div class="helpinfo-title">关注我们</div>
              <ul>
                <li>
                  <span>微信扫码立即关注</span>
                </li>
              </ul>
              <div class="QRcode_img">
                <i></i>
                <span>官方公众号</span>
              </div>
            </div>
          </div>
        </div>
        <div class="helpinfo_seo">
          <p>
            <a :href="host.sgsonlineUrl + '/overview/aboutSGS'"
              class="sgs-detail-title">SGS是专业的第三方检测、认证机构，拥有国际专家团队为您提供专业的检测认证等服务，欢迎来电咨询。</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { host } from 'src/config'
export default {
  name: 'PortalFooter',
  props: {
    env: {
      type: String,
      default: 'local',
    },
  },
  data() {
    return {
      host: host(this.env),
    }
  },
  methods: {
    handleHotline() {
      this.$alert(
        `<div class="tip_info_makesure" style=";border-radius: 0 0 5px 5px">
            <div class="tip_info"
                style="color: #000000;font-size: 14px;padding: 0 22px;line-height: 24px;margin-top: 18px;margin-bottom: 0px">
                <p>SGS在线商城客服热线：<br><a style="color: #ff5702" href="${this.host.sgsonlineUrl}/hotline" target="_blank" id='phoneNum'>4008-855-558</a>
                </p>
                <span>工作时间：</span>
                <p>周一~周六 9:00至17:00（节假日除外）<br>如遇忙线，请给我们
                    <a href="${this.host.sgsonlineUrl}/baojia" style="color:#ca4300" target="_blank">留言</a>，工作日最快2小时回复</p>
            </div>
        </div>`,
        '客服电话',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
        }
      )
    },
    handleHotlineOther() {
      this.$alert(
        `<div class="tip_info_makesure" style="border-radius: 0 0 5px 5px">
            <div class="tip_info"
                style="color: #000000;font-size: 14px;padding: 0 22px;line-height: 24px;margin-top: 18px;margin-bottom: 0px">
                <p>
                  <span>投诉专线：<span style="color: #ff5702">400-880-3955</span> （周一~周五9：00-17：00）</span><br>
                  <span>财务/发票：<span style="color: #ff5702">CNAP.PEK@sgs.com</span></span><br>
                  <span>招聘面试：<span style="color: #ff5702">CN.HR@sgs.com</span></span><br>
                  <span>廉政诚信：<span style="color: #ff5702">CN.CG@sgs.com</span></span>
                </p>
            </div>
        </div>`,
        '非业务咨询',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
        }
      )
    }
  },
  mounted() { },
}
</script>

<style lang='scss'>
@import './../../assets/style/mixin.scss';

.helpinfo {
  width: 100%;
  min-width: 1226px;
  padding: 61px 0 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #282828;
  background: #111111;
  margin: 0 auto;
  line-height: 1;

  .wrap-lg {
    width: 1226px;
    margin: 0 auto;
  }

  &:after {
    content: '\0020';
    display: block;
    visibility: hidden;
    clear: both;
    height: 0;
    overflow: hidden;
  }

  .helpinfo-item {
    float: left;
    width: 165px;

    .hotlineText,
    .highlight {
      color: $mainColor;
    }

    &.helpinfo-email {
      width: 224px;
      padding-right: 20px;
    }

    li {
      margin-bottom: 17px;
      color: #aaa;
      font-size: 16px;
    }
  }

  .helpinfo-title {
    color: #fff;
    font-size: 16px;
    margin: 0;
    margin-bottom: 30px;
  }

  ul {

    a,
    span,
    em,
    label {
      color: #858585;
      font-size: 14px;
    }

    a:hover {
      color: $mainColor;
    }

    label {
      display: inline-block;
      position: relative;
      top: -21px;
    }

    em {
      display: inline-block;
      line-height: 22px;
      width: 157px;
      height: 44px;
    }
  }

  .QRcode {
    float: right;
    border-left: 1px solid #333;
    width: 268px;
    padding-left: 52px;

    .QRcode_img {
      float: left;
      margin-top: 18px;
      margin-right: 35px;

      &.m-r {
        margin-right: 0;
      }

      i {
        width: 114px;
        height: 114px;
        background-image: url(./../../assets/images/portal/qcode_group.jpg);
        background-size: cover;
        display: block;
      }

      span {
        padding-top: 18px;
        width: 114px;
        text-align: center;
        font-size: 14px;
        color: #858585;
        display: block;
      }
    }
  }

  .helpinfo_seo {
    padding-top: 35px;
    font-size: 14px;

    * {
      color: #858585;
    }

    a:hover {
      color: $mainColor;
    }
  }
}
</style>